import { __ } from "src/libs/utilities"
import { ILandingSection, ITableRCell, SELECT_TYPE, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import TextBlock from "../../useful/TextBlock"
import TableThreadCellEditor from "../../landing-edit/table/TableThreadCellEditor"

/* Protopia Ecosystem component */
export interface ITableTreadCellProps {
   rowOrder: number
   th: ITableRCell
   section: ILandingSection
   primitive: TableContent

}
const TableTreadCell = (props: ITableTreadCellProps): JSX.Element => {
    const length        = props.primitive.threads.cells.length
    const width: string = `${100 / length}%`
    return <th key={ props.rowOrder } className="position-relative" style={{width}}>
        <TableThreadCellEditor {...props}>
            <TextBlock 
                editType={ SELECT_TYPE.TABLE_THREAD }
                section={ props.section || {} as ILandingSection}
                data={ props }
                columns={ 1 }
                text={  props.th.text }
            />
        </TableThreadCellEditor>
    </th>
}
export default TableTreadCell